export const DEFAULT_ANIM_FRAME_RATE = 8;

export const GITHUB_URL = 'https://github.com/NevaMind-AI/memU';
export const DISCORD_URL = 'https://discord.gg/memu';
export const MEDIUM_URL = 'https://medium.com/@memU_ai';
export const X_URL = 'https://x.com/memU_ai';
export const DASHBOARD_URL = 'https://app.memu.so';

// Video configuration
export const YOUTUBE_VIDEO_ID = 'qZIuCoLglHs';
export const YOUTUBE_VIDEO_URL = 'https://www.youtube.com/watch?v=qZIuCoLglHs';

// Email configuration
export const CONTACT_EMAIL = 'contact@nevamind.ai';
export const REQ_DEMO_EMAIL_SUBJECT = 'Request for memU Demo';
export const REQ_DEMO_EMAIL_BODY = 'Hi memU,\nI\'m interested in learning more about memU and how it can help [briefly describe your use case or problem, e.g., improve our workflow efficiency / enhance customer engagement].\nWould it be possible to schedule a short demo at your earliest convenience?';


// mob
export const MOB_EVENT_TYPE_EVENT = 'event';
export const MOB_EVENT_TYPE_PAGE_VIEW = 'page_view';